import React from 'react'

const BusinessDetails = () => {
    return (
        <>
            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    פרטי ביטוח עסק
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שם העסק
                        </div>
                        <div className="value">
                            <input type='text' value={''} />

                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מבנה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            צד ג'
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סחורה בהעברה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            כתובת
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            תכולה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            חבות מעבידים
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            רעידת אדמה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BusinessDetails